export const QUALIFY_METHODS = {
  automatic: {
    label: 'Automatic',
    value: 'automatic',
    variant: 'invited',
    showChevron: false,
    clickable: false,
  },
  manual: {
    label: 'Manual',
    value: 'manual',
    variant: 'responded',
    showChevron: false,
    clickable: false,
  },
};

export const MOCK_OPT_IN_FORMS = [
  {
    id: '1',
    name: 'ABC Fit Screener',
    qualifyMethod: QUALIFY_METHODS.automatic,
    project: { name: 'Onboarding Study', icon: '🧠' },
    sent: 142,
    completed: 98,
    incomplete: 44,
    created: 'June 12, 2026',
  },
  {
    id: '2',
    name: 'New User Intake',
    qualifyMethod: QUALIFY_METHODS.manual,
    project: { name: 'Growth Research', icon: '🧠' },
    sent: 88,
    completed: 61,
    incomplete: 27,
    created: 'June 8, 2026',
  },
  {
    id: '3',
    name: 'Enterprise Fit Check',
    qualifyMethod: QUALIFY_METHODS.automatic,
    project: { name: 'Enterprise Pilot', icon: '🧠' },
    sent: 56,
    completed: 40,
    incomplete: 16,
    created: 'May 30, 2026',
  },
  {
    id: '4',
    name: 'Churn Risk Screener',
    qualifyMethod: QUALIFY_METHODS.manual,
    project: { name: 'Retention Study', icon: '🧠' },
    sent: 120,
    completed: 75,
    incomplete: 45,
    created: 'May 22, 2026',
  },
  {
    id: '5',
    name: 'Beta Waitlist Form',
    qualifyMethod: QUALIFY_METHODS.automatic,
    project: { name: 'Product Beta', icon: '🧠' },
    sent: 210,
    completed: 180,
    incomplete: 30,
    created: 'May 14, 2026',
  },
];
